import React from 'react';
import useMedia from 'use-media';
import { Label } from '../atoms/label';
import { RadioButton } from '../atoms/radioButton';
export const RadioButtonForm = (props) => {
    const { state, onChange } = props;
    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div className={props.wrapClassName}>
            <Label label={props.label} className={props.titleClassName} />
            <RadioButton
                data={props.data}
                id={props.id}
                style={props.style}
                name={props.name}
                inputClassName={props.inputClassName}
                labelClassName={props.labelClassName}
                onChange={onChange}
                disabled={props.disabled}
            />
        </div>
    );
}
